import { CommonModule } from '@angular/common';
import { Component, computed, Input } from '@angular/core';
import { CLIENT_SCENARIOS, ClientScenario, ScenarioCopy } from '../../../model/mid-mapping-banner';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-client-alert-banner',
  standalone: true,
  imports: [CommonModule,MatIconModule],
  templateUrl: './client-alert-banner.component.html',
  styleUrl: './client-alert-banner.component.scss'
})
export class ClientAlertBannerComponent {
@Input({ required: true }) clientId!: number | string;

  scenario = computed<ClientScenario | null>(() => {
    const clientId = Number(this.clientId);
    if (!Number.isFinite(clientId)) return null;
    return CLIENT_SCENARIOS[clientId] ?? null;
  });

  copy = computed(() =>
    this.scenario() ? ScenarioCopy[this.scenario()!] : null
  );
}

